<template>
    <div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData">
                <div class="resumeList">
                    <div v-for="(item, i) in resumeList" :key="i" class="taskItem flex-center"
                        @click="$router.push('/interviewInfo?type=1&task_id=' + item.task_id)">
                        <van-image class="taskImg"  :src="require('../../../assets/image/tags/jianlishaxuan.png')"  />
                        <div class="taskRight">
                            <h5>{{ item.task_name }}</h5>
                            <div class="line2 flex-center">
                                <div v-if="item.task_tag == '高管'">{{ item.task_tag }}</div>
                                <p>应聘者: {{ item.applicant_name }}</p>
                            </div>

                            <p class="flex-center">
                                <span>{{ item.start_time }}-{{ item.end_time }}</span>
                                <span>发布人: {{ item.crate_name }}</span>
                            </p>
                            <div class="taskBottom flex-center">
                                <div class="prise">
                                    <img src="@/assets/image/prise.png" alt="" />
                                    <span>{{ moneyFormat(item.task_bonus) }}</span>
                                </div>
                                <div class="fillIn" v-if="item.is_permission == 1">
                                    <span v-if="item.is_write == 0"
                                        @click.stop="$router.push('/addAssessment?type=1&task_id=' + item.task_id)">
                                        填写简历评估表</span>
                                    <span class="disable" v-else> 已完成评估</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </van-list>
        </van-pull-refresh>

    </div>
</template>

<script>
import { resumeListApi } from "@/api/api/resume";
export default {
    data() {
        return {
            resumeList: [],
            total: null,
            params: {
                status: "1",
                page: 0,
                size: 10,
            },
            list: [],
            loading: false,
            finished: false,
            refreshing: false,
        }
    },
    methods: {
        async getData() {
            this.loading = true;
            if (this.total == this.resumeList.length) {
                this.finished = true
                //  console.log('nomore')
                return
            }
            this.params.page++
            let res = await resumeListApi(this.params);
            let resData = res.data.data
            this.$emit('setTabNum', resData.count_data)
            this.resumeList = [...this.resumeList, ...resData.data]
            this.total = resData.total
            // console.log(resData);
            this.refreshing = false //关闭下拉刷新组件状态
            this.loading = false; //关闭列表组件加载状态
        },
        onRefresh() {
            console.log('下拉刷新');
            this.params.page = 0
            this.resumeList = []
            this.finished = false;
            this.getData();
        },
    }
}
</script>

<style>
</style>